import _pick from 'lodash/pick';
import _functions from 'lodash/functions';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Matches from '../Common/Matches';
import Pagination from '../Common/Pagination';
import Results from '../Common/Results';
import StoriesForm from './components/StoriesForm';
import StoriesList from './components/StoriesList';
import * as actions from './stories.actions';

/**
 * Stories tab content presentational component
 */
export class Stories extends PureComponent {
    static propTypes = {
        /**
         * Query string
         */
        query: PropTypes.string.isRequired,
        /**
         * Min publish date
         */
        from: PropTypes.string,
        /**
         * Max publish date
         */
        to: PropTypes.string,
        /**
         * Stories result items list
         */
        items: PropTypes.arrayOf(PropTypes.shape({
            /**
             * Story title
             */
            title: PropTypes.string.isRequired,
            /**
             * Story publish date
             */
            published_at: PropTypes.string.isRequired,
            /**
             * Story text
             */
            body: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.arrayOf(PropTypes.string),
            ]).isRequired,
        })).isRequired,
        /**
         * Cound if items found
         */
        itemsNum: PropTypes.number.isRequired,
        /**
         * Loading flag
         */
        fetching: PropTypes.bool.isRequired,
        /**
         * Error flag
         */
        fetchFailed: PropTypes.bool.isRequired,
        /**
         * Current page number
         */
        page: PropTypes.number.isRequired,
        /**
         * Total pages
         */
        pagesNum: PropTypes.number.isRequired,
        /**
         * Action for fetch stories
         */
        fetchStories: PropTypes.func.isRequired,
        /**
         * Action for query for change
         */
        changeSearch: PropTypes.func.isRequired,
        /**
         * Action for page change
         */
        changePage: PropTypes.func.isRequired,
    }

    static defaultProps = {
        from: null,
        to: null,
    }

    componentDidMount() {
        this.props.fetchStories();
    }

    componentWillReceiveProps(nextProps) {
        if (['query', 'from', 'to', 'page'].some(key => this.props[key] !== nextProps[key])) {
            this.props.fetchStories();
        }
    }

    render() {
        const {
            query,
            from,
            to,
            fetching,
            fetchFailed,
            items,
            itemsNum,
            page,
            pagesNum,
            changeSearch,
            changePage,
        } = this.props;
        return (
            <div className="search-tab__stories">
                <StoriesForm
                    query={query}
                    from={from}
                    to={to}
                    onSubmit={changeSearch}
                />
                <h2 className="search-resultHeader">
                    Matches <Matches itemsNum={itemsNum} />
                </h2>
                <Results
                    itemsNum={itemsNum}
                    fetching={fetching}
                    error={fetchFailed}
                >
                    <StoriesList items={items} />
                </Results>
                <Pagination
                    totalPagesNum={pagesNum}
                    displayedPagesNum={5}
                    page={page}
                    onPageChange={changePage}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state.stories;
}

/**
 * Stories container component
 */
export default connect(mapStateToProps, _pick(actions, _functions(actions)))(Stories);



// WEBPACK FOOTER //
// ./src/js/Stories/Stories.jsx